function CollectionScript() {
  document.querySelectorAll('.main-collection-grid__empty[data-empty-state-collection-title]').forEach((emptyState) => {
    const message = emptyState.querySelector('[data-empty-state-message]');
    if (!message) return;

    const collectionTitle = emptyState.dataset.emptyStateCollectionTitle || '';
    const url = new URL(window.location.href);
    const productTypeValues = url.searchParams.getAll('filter.p.m.custom.filter_product_type');
    const labels = [];

    if (productTypeValues.includes('VEGAN')) labels.push('VEGAN');
    if (productTypeValues.includes('GLUTEN-FREE')) labels.push('GLUTEN-FREE');

    if (labels.length > 0) {
      message.textContent = `There are currently no ${labels.join(', ')} options of ${collectionTitle}`;
    } else {
      message.textContent = `There are currently no options of ${collectionTitle}`;
    }
  });

  document.querySelectorAll('.Collection_reference_list_slider').forEach(el => {

    if (!el.classList.contains('swiper-initialized')) {

      let lastActiveSlide = null;
      let isUserInteracting = false;

      const swiper = new Swiper(el, {
        loop: false,
        grabCursor: false,
        spaceBetween: 16,
        slidesPerGroup: 1,
        slidesPerView: "auto",
        watchSlidesProgress: true,
        draggable: true,
        autoHeight: false,
        watchOverflow: true,
        threshold: 10,
        mousewheel: {
          forceToAxis: true
        },
        observer: true,
        observeParents: true,
        freeMode: true,

        breakpoints: {
          0: {
            freeMode: false,
            spaceBetween: 8,
            slidesPerView: "auto"
          },
          750: {
            spaceBetween: 16,
            slidesPerView: "auto"
          },
          990: {
            spaceBetween: 16,
            slidesPerView: "auto"
          }
        },

        on: {
          touchStart: () => isUserInteracting = true,
          touchEnd: () => {
            setTimeout(() => isUserInteracting = false, 100);
          }
        }
      });

      function scrollToCustomActive() {
        if (isUserInteracting) return;

        const activeSlide = el.querySelector('.swiper-slide.active');
        if (!activeSlide || activeSlide === lastActiveSlide) return;

        lastActiveSlide = activeSlide;

        const slides = [...el.querySelectorAll('.swiper-slide')];
        const index = slides.indexOf(activeSlide);

        if (index !== -1) {
          swiper.slideTo(index, 300);
        }
      }

      // Initial run
      scrollToCustomActive();

      // Observe class changes
      const observer = new MutationObserver(() => {
        scrollToCustomActive();
      });

      observer.observe(el.querySelector('.swiper-wrapper'), {
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
    }
  });

  window.addEventListener("scroll", function () {
    const element = document.querySelector(".Reference_main_new");
    
    if (!element) return;

    const rect = element.getBoundingClientRect();

    if (rect.top <= 0) {
      document.body.classList.add("collection_fixed");
    } else {
      document.body.classList.remove("collection_fixed");
    }
  });

}

CollectionScript();

document.addEventListener("CollectionScript:init", CollectionScript);
